import { Backend } from '.';

interface PaymentCallbackResponse {
  order_id: string;
  simple_token: string;
}

export async function paymentDone(
  contractor: string,
  orderId: string,
  xToken: string,
  additionalParams?: { [key: string]: string }
) {
  return Backend.post<PaymentCallbackResponse>(`/shopping/payment/done`, {
    body: JSON.stringify({
      contractor,
      order_id: orderId,
      xtoken: xToken,
      ...additionalParams,
    }),
  });
}

export async function paymentAborted(
  contractor: string,
  orderId: string,
  xToken: string,
  additionalParams?: { [key: string]: string }
) {
  return Backend.post<PaymentCallbackResponse>(`/shopping/payment/abort`, {
    body: JSON.stringify({
      contractor,
      order_id: orderId,
      xtoken: xToken,
      ...additionalParams,
    }),
  });
}
